// extracted by mini-css-extract-plugin
export default {"mabf_container":"S1_BestFit_mabf_container__G0Lhk","mabf_desc":"S1_BestFit_mabf_desc__srT1Y"};